import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "..";
import { EntityId } from "@reduxjs/toolkit";
import { EnqueueFetcher } from "../Thunks/enqueueFetcher";
import { useEffect } from "react";

type EnqueueFetchById<T, Id extends EntityId> = InstanceType<typeof EnqueueFetcher<T, Id>>["enqueueFetchById"]

export function entityByIdWithStatusHookFactory<T, Id extends EntityId >(
  fetchThunk: EnqueueFetchById<T, Id>,
  selector: (state: RootState, id: Id) => T,
  loadingSelector: (state: RootState, id: Id) => boolean,
): (id?: Id) => ({entity: T | undefined, isLoading: boolean}) {

  return (id?: Id) => {

    const dispatch = useAppDispatch();

    const entity: T | undefined = useSelector((state: RootState) => {if (id) {return selector(state, id)}});

    const isLoading = useSelector((state: RootState) => {
      if (id) {
        return loadingSelector(state, id)
      }
      return true;
    }
    );
    useEffect(() => {
      if (id) {
        dispatch(fetchThunk(id));
      }
    }, [id, dispatch]);
    
    return { entity, isLoading };
  };
}

